/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { ActionTypes } from 'app/store/actions/reset-store.action';

export function clearState(reducer) {
  return (state, action) => {
    if (action.type === ActionTypes.RESET_STORE) {
      state = undefined;
    }

    return reducer(state, action);
  };
}
